module.exports = __webpack_public_path__ + "img/AFRICA_EGGS.850cc6ec.png";